export default __webpack_public_path__ + "static/Profile-Michiel_Andrea-792e3e687aaf9a63ff901a0f6ced98f0.png";